// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"747":"e2dbe39d","1403":"34bffef3","7762":"00822a1b"}[chunkId] + ".chunk.css";
};